<div
    (click)="onClick()"
    class="d-flex rounded-2 background-light-gray m-1 p-2 gap-2"
    [ngClass]="{'pointer pointer-hover-blue': userStore.canEdit()}">
    <app-bluetooth-svg [status]="Status.READY_FOR_ONBOARDING" class="img-fluid img-max px-2"/>
    <div class="d-flex flex-column justify-content-center">
        <span class="fw-bold">{{ id() | slice:-5 }}</span>
        {{ userStore.canEdit() ? 'Select to start onboarding' : '' }}
    </div>
</div>
